import {
  ArrowDataTransferHorizontalIcon,
  Car03Icon,
  User03Icon,
} from '@hugeicons/core-free-icons';
import { NavItem } from 'svnxii-ng-shared/components';

export const LOGISTICS_NAV_ITEMS: NavItem[] = [
  {
    title: 'Bulk Car Transfer',
    icon: ArrowDataTransferHorizontalIcon,
    route: '/app/logistics/bulk-car-transfer',
  },
  {
    title: 'Logistic Cars',
    icon: Car03Icon,
    route: '/app/logistics/logistic-cars',
  },
  {
    title: 'Account',
    devFeature: true,
    icon: User03Icon,
    route: '/app/logistics/notifications',
  },
];
